import React, {useEffect, useRef, useState} from 'react';
import {Strings} from '../../constants';
import {emailRegex, hashtagRegex, invalidMentionRegex, mentionRegex, urlRegex} from '../../utils';
import './styles.scss';

type Props = {
  children: string;
  cls?: string;
  height: number;
};

/**
 * For rendering text supporting see more & see less
 */
export const SeeMoreText: React.FC<Props> = ({children, cls, height}) => {
  const [seeMore, setSeeMore] = useState<boolean>(true);
  const [showSeeMore, setShowSeeMore] = useState<boolean>(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef?.current) {
      contentRef.current.scrollHeight > height && setShowSeeMore(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentRef, children, height]);

  const getParsedChildren = (): string => {
    children.match(urlRegex) &&
      (children = children.replace(
        urlRegex,
        (_match, url) => `<a href='${(url.includes('http') ? '' : 'https://') + url}' target='_blank'>${url}</a>`,
      ));
    children.match(emailRegex) &&
      (children = children.replace(emailRegex, (match, _email) => `<a href='mailto:${match}' target='_blank'>${match}</a>`));
    children.match(mentionRegex) &&
      (children = children.replace(mentionRegex, (_match, name, _id) => `<span style='font-weight: bold;'>${name}</span>`));
    children.match(invalidMentionRegex) && (children = children.replace(invalidMentionRegex, (_match, name) => name));
    children.match(hashtagRegex) &&
      (children = children.replace(hashtagRegex, (match, _name) => `<span style='font-weight: bold'>${match}</span>`));
    return children;
  };

  return (
    <>
      <div
        className={`content ${cls || ''}`}
        ref={contentRef}
        style={{...(showSeeMore && seeMore && {height: `${height}px`})}}
        dangerouslySetInnerHTML={{__html: getParsedChildren()}}
      />
      {showSeeMore && (
        <span className="fw-bold" onClick={() => setSeeMore(s => !s)} role="button" style={{padding: '15px'}}>
          {seeMore ? Strings.SEE_MORE : Strings.SEE_LESS}
        </span>
      )}
    </>
  );
};
